import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { OrganizationConfigs } from '@sydle/ui-api';

export type EnvState = {
  requestParams?: any;
  organizationConfigs?: OrganizationConfigs;
  currentLanguage?: string;
};

const envSlice = createSlice({
  name: 'env',
  initialState: {} as EnvState,
  reducers: {
    setEnv: (state, { payload: { requestParams } }: PayloadAction<EnvState>) => {
      state.requestParams = requestParams;
    },
    setOrganizationConfigs(state, { payload }: PayloadAction<OrganizationConfigs>) {
      state.organizationConfigs = payload;
      state.organizationConfigs = payload;
    },
    setCurrentLanguage(state, { payload: { lang } }: PayloadAction<{ lang: string }>) {
      state.currentLanguage = lang;
    },
  },
});

export const { setEnv, setOrganizationConfigs, setCurrentLanguage } = envSlice.actions;

export default envSlice;
